import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';

import { BehaviourListModel } from '../../../../../../../core/models/common.models';

@Component({
  selector: 'app-define-behavior-wizard-behavior-types-step',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzFormModule,
    NzButtonModule,
    NzCheckboxModule,
    NzInputModule,
    NzDividerModule,
  ],
  templateUrl: './define-behavior-wizard-behavior-types-step.component.html',
  styleUrl: './define-behavior-wizard-behavior-types-step.component.scss',
})
export class DefineBehaviorWizardBehaviorTypesStepComponent {
  @Input() form!: FormGroup;
  @Input() isRequired = false;
  @Input() categoryName = '';
  @Input() behaviourSubCategoryList: BehaviourListModel[] = [];
  @Input() behaviorTypeDescriptionControls: FormGroup[] = [];
  @Input() onCheckboxChange!: (
    controlName: string,
    checked: boolean,
    value: number
  ) => void;
  @Input() onBehaviorTypeChange!: (
    checked: boolean,
    category: BehaviourListModel
  ) => void;
  @Input() onControlInputChange!: (
    event: Event,
    control: AbstractControl | null
  ) => void;
  @Input() getBehaviorTypeDescriptionTitle!: (id: number) => string;
  @Input() trackById!: (index: number, item: { id: number }) => number;
  @Input() trackByIndex!: (index: number) => number;
  @Output() openFunctionalEquivalent = new EventEmitter<void>();
}
